module.exports = EchoChannels = {
    GLOBAL: "uma.global",
    PRIVATE: {
        GLOBAL: "uma.global",
        SETTINGS: "uma.settings",
        MACHINES: (machineId) => "uma.machines." + machineId,
        PRODUCTION_LINES: (productionLineId) => "uma.production-line." + productionLineId,
        GLOBAL_PRODUCTION: "uma.global.production",
        USER: (userId) => "uma.user." + userId,
    },

}
